import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { RecommendationSetting } from '@/pages/mortgage-workflow/routes/Recommendation/types';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getRecommendationSetting: builder.query<
      ApiResponse<{ id: number; key: string; value: RecommendationSetting }>,
      string
    >({
      query: (key: string) => {
        return {
          url: `/v1/settings/recommendation/${key}`,
        };
      },
    }),
  }),
});

export const { useGetRecommendationSettingQuery } = settingsApi;
